import { memo } from "react";



export const Setting = memo(() => {
    return (
        <section>
            セッティングページです
        </section>
    )

})